module.exports = __webpack_public_path__ + "static/media/preventivostickets-06-amarillo.68ec3032.svg";